module.exports = __webpack_public_path__ + "static/pexels-photo-530024-900x500-8c8bdf2959ca2db46503ba47223df280.jpg";